import ComponentsBreadcrumb from "src/layout/componentsBreadcrumb";
import KpiComponent from "./kpiComponent";
import CryptoBalancesChart from "./cryptoBalancesChart";
import TransactionsChart from "./transactionsChart";
import CardBalancesChart from "./cardBalancesChart";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppTabsComponent from "src/components/shared/commonScreens/apptabsComponent";
import { useNavigate } from "react-router-dom";
import RecentTransactions from "./recentTransactions";
import CardsKpi from "./cardsKpi";

const BladesDashboard = () => {
  const Permissions = useSelector((store) => store.permissions?.featurePermissions?.['dashboard']?.permissions);
  const [moduleName, setModuleName] = useState();
  const [breadCrumbList, setBreadCrumbList] = useState();
const navigate=useNavigate()

  useEffect(() => {
    let _permession = Permissions?.tabs?.find((item) => {
      if (item.isEnabled) return item;
    });
    setModuleName(_permession?.name);
    breadCrumbSetUp(_permession?.name)
  }, [Permissions])
  const breadCrumbSetUp = (tabName) => {
    setBreadCrumbList([{ id: '1', bname: 'Dashboard', url: "" },
    { id: '2', bname: tabName }
    ])
  }
  const handleTabChange = (tabName, isShowDenied) => {
    if (isShowDenied) {
      navigate(`/accessdenied`)
    } else {
      setModuleName(tabName);
      breadCrumbSetUp(tabName);
    }
  }

  const renderCharts = () => {
    return (
      <div className="mt-4 grid lg:grid-cols-2 gap-6 max-sm:overflow-auto">
       {moduleName != 'Wallets'&& moduleName != 'Payments' &&  <div className="bg-light-cardBg border border-light-cardBorder rounded-lg p-4 drop-shadow-sm bg-blueimg">
          <div className="kpi-section-style h-full">
          <h3 className='text-light-valueColor font-semibold text-lg dark:text-dark-valueColor'>
              {moduleName === 'Cards' ? 'Cards Balances' : 'Fiat Balances'}
            </h3>
            <CardBalancesChart module={moduleName} />
          </div>
        </div>}
       { moduleName != 'Banks'&& <div className="bg-light-cardBg border border-light-cardBorder rounded-lg p-4 drop-shadow-sm bg-blueimg">
          <div className="kpi-section-style h-full barchart-section">
            <h3 className='text-light-valueColor font-semibold text-lg dark:text-dark-valueColor'>
              {moduleName === 'Cards' ? 'Total Cards' : 'Crypto Balances'}
            </h3>
            <CryptoBalancesChart module={moduleName} />
          </div>
        </div>}
        <div className="bg-light-cardBg border border-light-cardBorder rounded-lg p-4 drop-shadow-sm bg-blueimg">
          <div className="kpi-section-style h-full">
            <TransactionsChart module={moduleName} seriesKey={"transactionsModels"}/>
          </div>
        </div>

      {moduleName == 'Exchange' && <div className="bg-light-cardBg border border-light-cardBorder rounded-lg p-4 drop-shadow-sm bg-blueimg">
          <div className="kpi-section-style h-full">
          <RecentTransactions module={moduleName} seriesKey={"transactionsModels"} />
          </div>
        </div>}
        {moduleName === 'Cards' && <div className="bg-light-cardBg border border-light-cardBorder rounded-lg p-4 drop-shadow-sm bg-blueimg">
          <div className="kpi-section-style h-full">
          <TransactionsChart module={"cryptoTransactions"} seriesKey={"transactionsModels"}/>
          </div>
        </div>}

      </div>
    );
  };

  return (
    <div>
      <div className='mb-4'>
        <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
      </div>
      {moduleName && moduleName !=='Cards' && <KpiComponent module={moduleName} customClass='xl:grid-cols-4 lg:grid-cols-2 gap-4' shouldFetch={true} />}
      {moduleName && moduleName ==='Cards' && <CardsKpi module={moduleName} customClass='xl:grid-cols-4 lg:grid-cols-2 gap-4' shouldFetch={true} url="GasStation"/>}
      <><div>
        <AppTabsComponent screenName={"dashboard"} handleChange={(key,isDenied)=>handleTabChange(key,isDenied)}/>
      </div>
      {(moduleName === 'Exchange' || moduleName === 'Payments' || moduleName === 'Banks' || moduleName === 'Wallets' || moduleName === 'Cards') && renderCharts()}</>
    </div>
  );
};

export default BladesDashboard;
